<template>
  <teleport to="body">
    <div class="modal" @click="closeModal" v-if="isOpen">
      <div class="content" @click.stop>
        <font-awesome-icon class="exit" icon="fa-xmark" @click="$emit('close')" />
        <form class="details-form" @submit.prevent="confirm">
          <h3>{{ title }}</h3>
          <div class="name input-container">
            <label for="name">First Name </label>
            <input v-model="staffCopy.value.firstName" type="text" id="name" />

            <label for="name">Last Name </label>
            <input v-model="staffCopy.value.lastName" type="text" id="name" />
          </div>

          <div class="input-container">
            <label for="dob"> Date of birth </label>
            <input v-model="staffCopy.value.dob" type="date" id="dob" />
          </div>

          <div class="input-container">
            <label for="email"> Email </label>
            <input v-model="staffCopy.value.email" type="email" id="email" />
          </div>

          <div class="checkbox">
            <label for="manager"> Manager </label>
            <input v-model="staffCopy.value.manager" type="checkbox" id="manager" />
          </div>

          <div class="input-container">
            <label for="mobile"> Mobile </label>
            <input v-model="staffCopy.value.mobile" type="text" id="mobile" />
          </div>

          <div class="input-container">
            <label for="startDate"> Start date </label>
            <input :value="formatDate(staffCopy.value.startDate)" @change="staffCopy.value.startDate = $event.target.value" type="date" id="startDate" />
          </div>

          <div class="input-container toggle-row">
            <label for="active-toggle"> Active </label>
            <ToggleSwitch :modelValue="staffCopy.value.active" :modelName="'active-toggle'" @update:modelValue="staffCopy.value.active = $event" />
          </div>

          <div class="input-container roles">
            <label for="roles"> Roles</label>
            <p class="roles-hint">Select the roles to apply to this employee</p>
            <RolesComponent :userRoles="staffCopy.value.roles" @checked="handleCheckedbox" id="roles" />
          </div>

          <div class="actions">
            <button type="button" @click="closeModal">Cancel</button>
            <button type="submit">Save</button>
          </div>
        </form>
      </div>
    </div>
  </teleport>
</template>

<script>
import { ToggleSwitch } from "@monolith/components";
import RolesComponent from "./RolesComponent.vue";
export default {
  name: "UserDetailsModal",
  components: {
    RolesComponent,
    ToggleSwitch,
  },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    staff: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      default: "Edit user details",
    },
  },
  data() {
    const staffValue = this.staff.value || {};
    return {
      staffCopy: {
        ...this.staff,
        value: {
          ...staffValue,
          active: staffValue.active !== false,
        },
      },
      displayName: "",
      dob: "",
      email: "",
      manager: false,
      mobile: "",
      payrollID: "",
      startDate: "",
      roles: "",
    };
  },
  emits: ["close", "confirm"],
  watch: {
    isOpen(isOpen) {
      if (!isOpen) return;
      const staffValue = this.staff.value || {};
      this.staffCopy = {
        ...this.staff,
        value: {
          ...staffValue,
          active: staffValue.active !== false,
        },
      };
    },
  },
  computed: {},
  methods: {
    handleCheckedbox(checkedBoxes) {
      this.staffCopy.value.roles = checkedBoxes;
    },

    closeModal() {
      this.$emit("close");
    },

    formatDate(isoString) {
      if (!isoString) return "";
      return isoString.split("T")[0];
    },

    confirm() {
      this.$emit("confirm", this.staffCopy);
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  width: min(92vw, 34rem);
  padding: 1.25rem;
  border-radius: 1rem;
  background: var(--primary-colour);
  box-shadow: var(--box-shadow);

  .details-form {
    gap: 1rem;

    .details-form h3 {
      margin: 0 0 0.25rem;
      font-size: 1.2rem;
      font-weight: 650;
      color: var(--text-colour);
    }

    .name {
      display: flex;
      gap: 0.5rem;
      label {
        white-space: nowrap;
      }

      input {
        width: calc(50% - 0.5rem);
      }
    }

    .details-form label:not(.checkbox-label) {
      font-size: 0.85rem;
      font-weight: 600;
      line-height: 1.2;
      color: var(--text-colour);
      letter-spacing: 0.01em;
    }

    .input-container {
      margin: 0.5rem 0;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      input {
        width: calc(100% - 2rem);
        box-shadow: var(--box-shadow);
        border: 1px solid var(--secondary-colour);
        border-radius: 0.5rem;
        padding: 0.5rem;
        margin: 0 0.5rem;
        color: var(--text-colour);
        background: var(--secondary-colour);
      }
    }

    .details-form input::placeholder {
      color: var(--text-colour);
    }

    .checkbox {
      display: flex;
      align-items: center;
      margin: 0 !important;
      color: var(--text-colour);
      label {
        margin: 0.5rem 0;
      }
      input[type="checkbox"] {
        margin: 0.5rem;
        height: 1.5rem;
      }
    }

    .actions {
      display: flex;
      justify-content: center;
      gap: 1rem;
      margin-top: 1rem;
    }

    .actions button {
      border: 0;
      border-radius: 0.25rem;
      padding: 0.5rem 1rem;
      cursor: pointer;
    }

    .actions button:active {
      transform: translateY(1px);
    }

    .actions button[type="button"] {
      background: var(--secondary-colour);
      color: var(--text-colour);
    }

    .actions button[type="submit"] {
      background: var(--action-colour);
      color: var(--text-colour);
    }

    .actions button:hover {
      filter: brightness(0.97);
    }

    .roles {
      display: flex;
      flex-direction: column;
    }

    .roles-hint {
      margin: 0.1rem 0 0.4rem;
      font-size: 0.78rem;
      color: var(--text-colour);
      opacity: 0.55;
    }
  }
}

@media (max-width: 640px) {
  .content {
    width: min(94vw, 34rem);
    padding: 1rem;
  }

  .actions {
    justify-content: stretch;
  }

  .actions button {
    flex: 1;
  }
}
</style>
